import { module } from 'stereomodularjs';
import Vue from 'vue';
import { compileToFunctions } from 'vue-template-compiler';
import axios from 'axios';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const template = this.el.nextElementSibling;
        const taxes = JSON.parse(this.el.dataset.taxes);
        template.remove();
        this.initVUE(template, taxes);
    }

    initVUE(template, taxes) {
        Vue.config.devtools = true;
        Vue.config.productionTip = false;
        template = template.innerHTML;
        const res = compileToFunctions(template);
        new Vue({
            el: this.el,
            data: {
                prices: [],
                pass: {
                    residence: '',
                    age: '',
                    marina: '',
                    type: 'individuel',
                    price: 0,
                },
                formComplete: false,
                isSubmitting: false,
                taxes: taxes,
            },
            methods: {
                async fetchPrices() {
                    return axios.get('/wp-json/pass/v1/prices?'+Math.random().toString(36).substring(2,7))
                        .then((response) => {
                            this.prices = response.data;
                            return response.data;
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                },
                formComplete() {
                    return this.pass.residence && this.pass.age && this.pass.marina && this.pass.type;
                },
                formatTaxes(price) {
                    let total_taxes = 0;
                    for (let i = 0; i < this.taxes.length; i++) {
                        total_taxes += parseFloat(price) * parseFloat(this.taxes[i].taux);
                    }

                    price = parseFloat(price) + parseFloat(total_taxes);
                    let number = new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' });
                    price = number.format(price);
                    // Remove the currency symbol
                    price = price.replace(/\$/g, '');
                    price = price.replace(',00', '');
                    return price;
                },
                async addToCart() {
                    this.isSubmitting = true;
                    let app = this;
                    if(this.formComplete && this.pass.price > 0){
                        if(this.pass.type == 'individuel' && !this.pass.first_name && !this.pass.last_name){
                            alert('Veuillez entrer votre prénom et nom de famille.');
                            this.isSubmitting = false;
                            return;
                        }
                        let metadata = this.pass;
                        let uniqueId = 'pass_' + this.pass.residence + '_' + this.pass.age + '_' + this.pass.marina + '_' + this.pass.type + '_' + Math.floor(Math.random() * 1000000) + 1;
                        let sku = 'pass_'+ this.pass.type;
                        let marina = this.pass.marina == 'oui' ? 'membre de la marina' : '';
                        await window.StereoStoreAddToCart({
                            id: uniqueId,
                            //sku: uniqueId,
                            type: 'pass',
                            quantity: 1,
                            name: 'Laissez-passer annuel ' + this.pass.type + ' ' + this.pass.residence + ' ' + this.pass.age + ' ' + marina,
                            description : 'Valide du 1er mai au 31 octobre ' + new Date().getFullYear(),
                            price: this.pass.price,
                            sku: sku,
                            metadata: JSON.stringify(metadata)
                        }).then(function(response){
                            app.isSubmitting = false;
                            window.location.href = '/panier/';
                        });
                    }
                }
            },
            watch: {
                pass: {
                    handler: function (val) {
                        let formComplete = this.pass.residence && this.pass.age && this.pass.marina && this.pass.type;
                        if(formComplete){
                            //Get price from prices where the options are included in each pass object
                            let price = this.prices.find((price) => {
                                if(!price.residence || !price.age || !price.marina || !price.type)
                                    return false;

                                if(price.residence.includes(this.pass.residence) && price.age.includes(this.pass.age) && price.marina.includes(this.pass.marina) && price.type.includes(this.pass.type))
                                    return true;
                            });
                            if(price){
                                this.pass.price = price.price;
                                this.formComplete = true;
                            } else {
                                alert('Il semblerait que le prix de votre pass ne soit pas disponible pour le moment. Veuillez contacter le service client.')
                                this.formComplete = false;
                            }
                        } else {
                            this.formComplete = false;
                        }
                    },
                    deep: true,
                },
            },
            mounted() {
                this.fetchPrices();
            },
            ...res,
        });
    }
}
